import { Controller } from "@hotwired/stimulus";

// Used by the `.searchbox` search fields on admin index pages. Two behaviours:
//   1. The initial focus is deferred one tick, so the rest of the mount finishes first.
//   2. A PERMANENT `focus->focus#onFocus` action snaps the caret to the end of the field's value
//      on every focus, not just the first - which is why this is not just an `autofocus` attribute.
export default class extends Controller {
  connect() {
    this.focusTimeout = setTimeout(() => this.element.focus(), 0);
  }

  disconnect() {
    clearTimeout(this.focusTimeout);
  }

  onFocus() {
    this.element.selectionStart = this.element.selectionEnd = this.element.value.length;
  }
}
